import { render, staticRenderFns } from "./ChordProTextAreaToolbar.vue?vue&type=template&id=6953ff55&scoped=true"
import script from "./ChordProTextAreaToolbar.vue?vue&type=script&lang=ts"
export * from "./ChordProTextAreaToolbar.vue?vue&type=script&lang=ts"
import style0 from "./ChordProTextAreaToolbar.vue?vue&type=style&index=0&id=6953ff55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953ff55",
  null
  
)

export default component.exports